import React, {Component} from "react";
import {withTranslate} from "react-redux-multilingual";
import globalMiddleware from "../../hocs/globalMiddleware";
import ProfileSidebar from "../../components/profile/ProfileSidebar";
import {connect} from "react-redux";
import {profile} from "../../store/actions/userActions";
import axios from "axios";
import {baseLink, editUserProfileUrl, getHeader, ResendCodeUrl} from "../../config";
import DatePicker from "react-datepicker";
import Moment from "moment"
import "react-datepicker/dist/react-datepicker.css";
import {setProfileSkeleton} from "../../skeleton";
import Dropzone from 'react-dropzone';
import ReactCrop from "react-image-crop";
import 'react-image-crop/dist/ReactCrop.css';
import {
    image64toCanvasRef,
    extractImageFileExtensionFromBase64,
} from "../../helpers/image";
import {showToast} from "../../helpers/magic";
import {clearError500, setCurrentRoute} from "../../store/actions/globalActions";
import Maintenance from "./UserHistory";


class Profile extends Component {
    constructor(props) {
        super(props);
        this.imagePreviewCanvasRef = React.createRef();
        this.isActive = localStorage.getItem("isActive") ? JSON.parse(localStorage.getItem("isActive")) : null;
        this.token = localStorage.getItem("access_token") ? JSON.parse(localStorage.getItem("access_token")) : null;
    }

    state = {
        isEdit: false,
        loading: false,

        name: null,
        email: null,
        mobile: null,
        gender: null,
        address: null,
        birthday: null,
        height: null,
        weight: null,

        validation: {
            name: {
                is_required: true,
                valid: false,
                msg: "The name field is required",
            },
            email: {
                is_required: true,
                valid: false,
                msg: "The email field name is required",
            }
        },

        validation_status: false,

        imageIsLoading: false,
        crop: {
            x: 10,
            y: 10,
            aspect: 1,
            width: 160,
        },

        popupIsShown: false,
        cropSaved: false,
    };

    onChange = (date) => {
        this.setState({birthday: Moment(date).format('YYYY-MM-DD')});
    };

    componentDidMount() {
        this.props.clearError500();
        this.props.profile();
        this.props.setCurrentRoute(window.location.href);
    };

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.authUser) {
            this.setState({
                name: nextProps.authUser.name,
                email: nextProps.authUser.email,
                mobile: nextProps.authUser.mobile,
                gender: nextProps.authUser.gender,
                address: nextProps.authUser.address,
                birthday: nextProps.authUser.birthday,
                height: nextProps.authUser.height,
                weight: nextProps.authUser.weight,
            })
        }
    }

    handleInputChange = (e, field = null) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };
    onEditProfileSubmission = (e) => {
        this.setState({
            loading: true,
        });
        e.preventDefault();
        const form = document.getElementById("update-form");

        if (this.state.email == null || this.state.email.length <= 0) {
            this.setState({
                emailError: "This field is required",
            })
        }
        axios.post(editUserProfileUrl, this.state, {headers: getHeader()}).then(res => {
            // stop loading
            this.setState({
                loading: false,
            });
            if (res.data.Error.code === 20) {
                form.reset();
                this.setState({
                    isEdit: false,
                    name: null,
                    email: null,
                    gender: null,
                    address: null,
                    birthday: null,
                    height: null,
                    weight: null,
                });
                this.props.profile();

            } else {
                switch (res.data.Error.code) {
                    default:
                        break;
                }
            }
        }).catch(error => {
            if (error) {
                console.log(error)
            }
        })
    };


    onDrop = (files, rejactedFiles) => {
        const currentFile = files[0];
        const myFileReader = new FileReader();
        myFileReader.addEventListener("load", () => {
            this.setState({
                image: myFileReader.result,
                popupIsShown: true,
            });

        }, false);
        myFileReader.readAsDataURL(currentFile)
    };
    // *********************************************** CROP STUFF ********************************************
    onCrop = (crop) => {
        console.log("on crop");
        this.setState({
            crop: crop
        })
    };

    imageLoaded = (image) => {
        this.setState({
            popupIsShown: true
        });
        console.log("loaded", image);
    };

    onCropComplete = (crop, pixelCrop) => {
        this.setState({
            popupIsShown: true
        });
        const canvasRef = this.imagePreviewCanvasRef.current;
        const image = image64toCanvasRef(canvasRef, this.state.image, pixelCrop);
        this.setState({
            image: image.src,
        });
    };
    cancelCrop = () => {
        this.setState({
            image: null,
            popupIsShown: false,
            crop: {
                x: 10,
                y: 10,
                aspect: 16 / 9,
                width: 160,
            },
        });
        this.imagePreviewCanvasRef = React.createRef();
    };

    cropSaved = () => {
        this.setState({
            cropSaved: true,
            popupIsShown: false,
            crop: {
                x: 10,
                y: 10,
                aspect: 1,
                width: 160,
            },
        });
        const fileExt = extractImageFileExtensionFromBase64(this.state.image);
        //const fileName = Date.now() + "." + fileExt;
        const imagePreviewCanvasRef = this.imagePreviewCanvasRef.current;
        const imageBase64 = imagePreviewCanvasRef.toDataURL("image/" + fileExt);
        this.imageUpload(imageBase64);
    };

    imageUpload = (imageBase64) => {
        this.setState({
            imageIsLoading: true,

        });
        const formData = new FormData();
        formData.append('image', imageBase64);

        axios.post(baseLink + "profile/set-image", formData, {
            headers: getHeader(),
            'Content-Type': 'multipart/form-data'
        }).then(res => {
            this.setState({
                imageIsLoading: false,
            });
            if (res.data.Response) {
                this.setState({
                    image: null,
                });
            }
            this.props.profile();

            showToast("Image uploaded successfully", "green");

            //document.getElementById("zone").innerText = "";
        }).catch(error => {
            if (error) {
                // clearAccessTokenAndRedirectToLogin(error);
                console.log(error);
            }
        });
    };
    resendCode = () => {
        // start loading
        this.setState({
            resendLoading: true,
        });
        axios.post(ResendCodeUrl, "", {headers: getHeader()}).then(res => {

        }).catch(error => {
            console.log(error);
        })
    };
    verifyAccount = async (e) => {
        e.preventDefault();
        await this.resendCode();
        window.location.href = "activate";
    }

    render() {

        const {authUser, authUserIsLoading} = this.props;
        if (this.props.error500) {
            return (
                <Maintenance/>
            )
        }
        /*
        const history = [
            {
                page: this.props.translate("home"),
                to: "/"
            }
        ];
        */

        return (
            <div id="profile">
                {/* *********************** Image Crop ************************** */}
                <div className="crop-image-box" hidden={!this.state.popupIsShown}>
                    <div className="crop-popup-overlay" style={{zIndex: 3}}></div>
                    <div className="crop-popup" style={{zIndex: 5}}>
                        <div className="container">
                            <h1 className="text-center">Crop Image</h1>
                        </div>
                        <ReactCrop
                            style={{width: "85%", margin: "auto"}}
                            onChange={this.onCrop}
                            src={this.state.image ? this.state.image : ""}
                            crop={this.state.crop}
                            onImageLoaded={this.imageLoaded}
                            onComplete={this.onCropComplete}
                        />

                        <div className="crop-control-btn">
                            <div className="container">

                                <button className="btn btn-primary" onClick={this.cancelCrop}>Cancel</button>
                                <button className="btn btn-primary" onClick={this.cropSaved}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    {
                        !authUserIsLoading ? <div className="row">
                            <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                                <div className="profile-card  shadow-4d">
                                    <a className="pull-right light-grey" style={this.props.language === "ar" ? {direction: "rtl"}: {direction: "ltr"}}href="/doctors/favourite">
                                        <img src="/images/followed-doctors.png"
                                             alt="heart"/><strong>&nbsp;{authUser.followed_doctors}</strong>&nbsp;
                                        {this.props.translate("followed_doctors")}
                                    </a>
                                    <a className="pull-left points-btn cursor-pointer" href="/cash-back">
                                        <img src="../images/cash.png"
                                             alt="heart"/>&nbsp;
                                        <span style={this.props.language === "ar" ? {direction: "rtl"}: {direction: "ltr"}}>{authUser.cash_back}&nbsp;{this.props.translate("currency")}</span></a>

                                    <div className="profile-image">
                                        <div className="avatar align-self-md-center">
                                            <img src={authUser.image} alt="placeholder"
                                                 className="img-fluid mb-4"/>
                                        </div>
                                        <span className="premium" hidden={authUser.is_premium === 0}><img
                                            alt="premium"
                                            src="../../images/premium.png"/></span>
                                        {/* *********************** Image Canvas ************************** */}
                                        <div className="text-center" hidden>
                                            <div className="cropped-canvas">
                                                {/*   <canvas  className="block" style={{width: "150px", height: "auto"}}
                                    ref={this.imagePreviewCanvasRef}/>*/}
                                                <div className="row">
                                                    <div className="col-md-2 col-md-offset-5 relative no-padding">
                                                        <canvas className="block"
                                                                style={{width: "100%", height: "auto"}}
                                                                ref={this.imagePreviewCanvasRef}/>
                                                        <div className="img-overlay-dropzone"
                                                             hidden>
                                                            <i className="fa fa-spinner fa-spin dropzone-loading"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<span className="loading-span" hidden={!this.state.imageIsLoading}>loading...</span>*/}
                                            </div>
                                            <hr/>
                                        </div>
                                        <div>
                                            <Dropzone onDrop={this.onDrop} multiple={false}>
                                                {({getRootProps, getInputProps}) => (
                                                    <div {...getRootProps()}>
                                                        <input {...getInputProps()} />
                                                        <span className="change-photo cursor-pointer"> <img alt="camera"
                                                                                                            src="../../images/change-photo.png"/></span>
                                                    </div>
                                                )}
                                            </Dropzone>
                                        </div>
                                    </div>
                                    <br/>
                                    <div className="profile-main-info text-center align-self-md-center ">
                                        <h4 className="text-center">{authUser.name}</h4>
                                        <h5 className="light-grey text-center">{"ID #" + authUser.unique_id}</h5>
                                        <button className="btn-style-less shadow-4d"
                                                style={this.props.language === "ar" ? {
                                                    width: "235px",
                                                    padding: "5px 10px"
                                                } : {width: "auto", padding: "0 10px"}}
                                                onClick={() => this.setState({isEdit: true})}><img
                                            alt="edit"
                                            src="../../images/edit.png"/>{this.props.translate("edit_profile")}
                                        </button>
                                    </div>
                                </div>
                                <div className="profile-details-area shadow-4d" hidden={this.state.isEdit}>
                                    <div className="profile-info">
                                        <h5 className="light-grey">{this.props.translate("main_info")}</h5>
                                        <ul>
                                            <li>
                                                <img src="/images/mail.png" alt="mail"/>
                                                {authUser.email}
                                            </li>
                                            <li>
                                                <img src="/images/phone.png" alt="phone"/>
                                                {authUser.mobile}
                                                {
                                                    this.token && this.isActive === 0 ?

                                                        <a onClick={(e) => this.verifyAccount(e)}
                                                           className="verify-btn cursor-pointer">{this.props.translate("verify")}</a>
                                                        : <span
                                                            className="verified-btn">{this.props.translate("verified")}</span>
                                                }
                                            </li>
                                            <li>
                                                <img src="/images/gender.png" alt="gender"/>
                                                {authUser.gender === 0 ? "Not Set" : authUser.gender === 1 ? "male" : "Female"}
                                            </li>
                                            <li>
                                                <img src="/images/location.png" alt="location"/>
                                                {authUser.address}
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="profile-extras">
                                        <h5 className="light-grey">{this.props.translate("extras")}</h5>
                                        <ul>
                                            <li>
                                                <img src="/images/birth-date.png" alt="birth-date"/>
                                                {authUser.birthday}
                                            </li>
                                            <li>
                                                <img src="/images/height.png" alt="height"/>
                                                {authUser.weight === 0 ? "Not Set" : authUser.weight}
                                            </li>
                                            <li>
                                                <img src="/images/weight.png" alt="weight"/>
                                                {authUser.height === 0 ? "Not Set" : authUser.height}
                                            </li>
                                        </ul>
                                    </div>


                                    <div className="plan-area">
                                        <a href="/premium">
                                            {
                                                authUser.is_premium === 1 && authUser.plan ?
                                                    <p className="no-margin">

                                                            <span
                                                                className="font-20 bolder">{authUser.plan.price + " "}</span>
                                                        <span
                                                            className="font-20 bolder">{this.props.translate("currency") + " /"} </span>
                                                        <span
                                                            className="font-15">{authUser.plan.months + " " + this.props.translate("months")}  </span>

                                                    </p> :
                                                    <p className="no-margin bolder">
                                                        <img
                                                            src="/images/premium.png"
                                                            alt="premium"/>{this.props.translate("upgrade_to_premium")}
                                                    </p>
                                            }
                                        </a>
                                    </div>
                                </div>
                                {/*edit profile*/}
                                <div className="profile-details-area shadow-4d" hidden={!this.state.isEdit}>
                                    <div className="profile-info">
                                        <h5 className="light-grey">{this.props.translate("edit_profile")}</h5>
                                        <form onSubmit={(e) => this.onEditProfileSubmission(e)} id="update-form">
                                            <div className="form-group validate-input">
                                                <label>{this.props.translate("name")}</label>
                                                <input id="name" type="text"
                                                       className="form-control input100 curvy-input"
                                                       value={this.state.name}
                                                       onChange={(e) => this.handleInputChange(e)}/>
                                                <span className="error-form red">{this.state.nameError}</span>
                                            </div>
                                            <div className="form-group validate-input">
                                                <label>{this.props.translate("email")}</label>

                                                <input id="email" type="text"
                                                       className="form-control input100 curvy-input"
                                                       onChange={(e) => this.handleInputChange(e)}
                                                       value={this.state.email}/>
                                                <span className="error-form red">{this.state.emailError}</span>
                                            </div>
                                            <div className="form-group validate-input">
                                                <label>{this.props.translate("gender")}</label>
                                                <select className="form-control font-20 height-50 curvy-input"
                                                        onChange={(e) => this.handleInputChange(e)} id="gender">
                                                    <option value="1">{this.props.translate("male")}</option>
                                                    <option value="2">{this.props.translate("female")}</option>
                                                </select>
                                            </div>
                                            <div className="form-group validate-input">
                                                <label>{this.props.translate("address")}</label>

                                                <input id="address" type="text"
                                                       className="form-control input100 curvy-input"
                                                       onChange={(e) => this.handleInputChange(e)}
                                                       value={this.state.address}/>
                                            </div>
                                            <div className="form-group validate-input">
                                                <label>{this.props.translate("birthday")}</label>
                                                <br/>
                                                <DatePicker
                                                    className="form-control input100 curvy-input"
                                                    onChange={this.onChange}
                                                    value={this.state.birthday}
                                                    format="yyyy-MM-dd"
                                                />
                                            </div>
                                            <div className="form-group validate-input">
                                                <label>{this.props.translate("height")}</label>

                                                <input id="height" type="text"
                                                       className="form-control input100 curvy-input"
                                                       onChange={(e) => this.handleInputChange(e)}
                                                       value={this.state.height}/>
                                            </div>
                                            <div className="form-group validate-input">
                                                <label>{this.props.translate("weight")}</label>

                                                <input id="weight" type="text"
                                                       className="form-control input100 curvy-input"
                                                       onChange={(e) => this.handleInputChange(e)}
                                                       value={this.state.weight}/>
                                            </div>
                                            <div className="container-login100-form-btn relative">
                                                <button type="submit"
                                                        className="submit-btn cursor-pointer curvy-input height-45">
                                                    {this.props.translate("submit")}
                                                </button>
                                                <span id="loading" className="submit-loading"
                                                      hidden={this.state.loading === false}>
                                                <img style={{width: "30px", height: "30px", marginTop: "15px"}}
                                                     src="/images/loading-white.svg" alt="loading"/>
                                                </span>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12 col-sm-12 col-xs-12 full-height">
                                <ProfileSidebar profile={authUser} loading={authUserIsLoading}/>
                            </div>
                        </div> : setProfileSkeleton()
                    }

                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        authUser: state.user.authUser,
        authUserIsLoading: state.user.authUserIsLoading,
        error500: state.global.error500,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        profile: () => {
            dispatch(profile())
        },
        setCurrentRoute: (route) => dispatch(setCurrentRoute(route)),
        clearError500: () => dispatch(clearError500())
    }
};

export default globalMiddleware(connect(mapStateToProps,
    mapDispatchToProps)(withTranslate(Profile)));